var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0502 19.28C16.0702 20.23 15.0002 20.08 13.9702 19.63C12.8802 19.17 11.8802 19.15 10.7302 19.63C9.29016 20.25 8.53016 20.07 7.67016 19.28C2.79016 14.25 3.51016 6.59 9.05016 6.31C10.4002 6.38 11.3402 7.05 12.1302 7.11C13.3102 6.87 14.4402 6.18 15.7002 6.27C17.2102 6.39 18.3502 6.99 19.1002 8.07C15.9802 9.94 16.7202 14.05 19.5802 15.2C19.0102 16.7 18.2702 18.19 17.0402 19.29L17.0502 19.28ZM12.0302 6.25C11.8802 4.02 13.6902 2.18 15.7702 2C16.0602 4.58 13.4302 6.5 12.0302 6.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.f5b993c5e6061da403320c235fc343ca.svg";
export { ForwardRef as ReactComponent };